import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LandingPageAppResource from "./LandingPageAppResource";
import Engine from "@milestoneslabs/milestones-js-engine";

class LandingPageEventAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-event';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/events';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'title',
      'timeStart',
      'timeEnd',
      'date',
      'location',
      'description',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPage: LandingPageAppResource,
    }
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      landingPage: 'landing_page_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    let rules = {
      landingPageUuid: {
        type: 'string',
      },
      title: {
        type: 'string',
        presence: {
          message: "^Please add a title.",
        },
        length: {
          maximum: 255,
          message: 'Title is too long (maximum is 255 characters)',
        },
      },
      date: {
        datetime: true,
        presence: {
          message: "^Please select a date."
        },
      },
      timeStart: {
        datetime: true,
      },
      timeEnd: {
        datetime: true,
      },
      location: {
        type: 'string',
        length: {
          maximum: 255,
          message: 'Address too long (maximum is 255 characters)',
        },
      },
      description: {
        type: 'string',
      },
    };

    if (this.timeEnd) {
      rules.timeStart.presence = {
        message: "^Please complete the start time."
      }
    }

    return rules;
  }

  apiPaths() {
    return {
      ...super.apiPaths(),
      addToCalendar: Engine.apiUrl(`${this.appResourceApiPrefix()}/{uuid}/add-to-calendar`)
    };
  }

  async addToCalendar() {
    if (this.uuid === null) {
      throw new Error('Uuid is missing!');
    }

    const url = this.apiPaths().addToCalendar.replace('{uuid}', this.uuid);

    this._emitter.emitSync('beforeAddToCalendar', this);
    const apiResponse = await Engine.get(url, {})
    this._emitter.emit('afterAddToCalendar', this, apiResponse);

    return apiResponse;
  }
}

export default LandingPageEventAppResource;
